import {
  getToken,
  setToken,
  getSimpleToken,
  setSimpleToken,
  removeToken,
  getSalaryPass,
  setSalaryPass,
  removeSalaryPass,
  getWechatAutoLoginFlag,
  setWechatAutoLoginFlag,
  removeWechatAutoLoginFlag,
  setWechatAutoLoginCode,
  removeWechatAutoLoginCode,
  getWechatAutoLoginCode,
  removeAppToken,
  setAppToken,
  removeCompanyCodeHeaderKey,
  getIndividualHeaderKey,
  removeIndividualHeaderKey,
  getAppToken
} from '@/utils/auth';

import {
  removePartnerToken
} from '@/utils/auth';

import {
  clearCookie
} from '@/utils/cookieUtil';

import { employeePasswordValidate, employeeSetOidByCode } from "@/api/employee/request";
import api from '@/api/list';
import jwt_decode from 'jwt-decode';

const user = {
  state: {
    token: getToken(),
    simpleToken:getSimpleToken(),
    salaryPass: getSalaryPass(),
    jwtDecode: getToken() && typeof getToken() != 'undefined' && getToken() != 'undefined' ? jwt_decode(getToken()) : {},
    showSalaryPass: false,
    checkedEsign: false,
    card_type: undefined,
    card_id: undefined,
    wechatAutoLoginTime: undefined,
    wechatAutoLoginTimeFlag: 0,
    wxMiniOpenId: "",//小程序openId
    browserUA: "",//判断浏览器
    enterRoute: "/",//进入的路由，用来做登录之后的重定向
    ecompanyCode: "",//logo
    ocompanyCode: "",//logo
    taskOrder: "",
    requestCounter: 0,
    enterRouteLoading: false,
    userInfo: {
        name: "",
        id:null,
        mobile:null
    },
    platformName:"工蚁宝",
    appToken:null
  },

  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    SET_WXMINIOPENID: (state, wxMiniOpenId) => {
      state.wxMiniOpenId = wxMiniOpenId;
    },
    SET_BROWSERUA: (state, browserUA) => {
      state.browserUA = browserUA;
    },
    SET_ENTERROUTE: (state, enterRoute) => {
      state.enterRoute = enterRoute;
    },
    SET_CHECKEDESIGN: (state, checkedEsign) => {
      state.checkedEsign = checkedEsign;
    },
    SET_CARDTYPE: (state, card_type) => {
      state.card_type = card_type;
    },
    SET_CARDID: (state, card_id) => {
      state.card_id = card_id;
    },
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_SIMPLE_TOKEN:(state,token)=>{
        state.simpleToken = token;
    },
    SET_APP_TOKEN: (state, token) => {
      state.appToken = token;
    },
    SET_JWTDECODE: (state, jwtDecode) => {
      state.jwtDecode = jwtDecode;
    },
    SET_SALARYPASS: (state, salaryPass) => {
      state.salaryPass = salaryPass;
    },
    SET_SHOWSALARYPASS: (state, isShow) => {
      state.showSalaryPass = isShow;
    },
    SET_WECHATAUTOLOGINTIME: (state, date) => {
      state.wechatAutoLoginTime = date;
    },
    SET_WECHATAUTOLOGINTIMEFLAG: (state, flag) => {
      state.wechatAutoLoginTimeFlag = flag;
    },
    SET_PLATFORM_NAME: (state, platformName) => {
        state.platformName = platformName;
    },
    SET_ECOMPANYCODE: (state, ecompanyCode) => {
        state.ecompanyCode = ecompanyCode;
      },
    SET_OCOMPANYCODE: (state, ocompanyCode) => {
      state.ocompanyCode = ocompanyCode;
    },
    SET_TASKORDER: (state, taskOrder) => {
      state.taskOrder = taskOrder;
    },
    SET_ENTER_ROUTE_LOADING: (state, enterRouteLoading) => {
      state.enterRouteLoading = enterRouteLoading;
    },
    RESET_REQUEST_COUNTER: (state) => {
      state.requestCounter = 0;
    },
    ADD_REQUEST_COUNTER: (state) => {
      state.requestCounter++;
    },
    DELETE_REQUEST_COUNTER: (state) => {
      if (state.requestCounter > 0) {
        state.requestCounter--;
      }
      //进入页面的请求数结束则将标志置为false
      if (state.requestCounter == 0) {
        state.enterRouteLoading = false;
      }
    },
  },

  actions: {
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (getToken()) {
          api.getActiveUserAllInfo().then((res) => {
            if (res.data.status == "200") {
              let user = res.data.data;
              if (user.headshot) {//处理头像
                user.headshot = process.env.VUE_APP_FILE_PATH + user.headshot
              }

              if (user.skillCertificateFiles) {//处理技能证书文件
                let files = []
                user.skillCertificateFiles.split(",").forEach((item, index) => {
                  files.push({
                    url: process.env.VUE_APP_FILE_PATH + item
                  })
                });
                user.skillCertificateFiles = files
              } else {
                user.skillCertificateFiles = []
              }
              commit('SET_USER_INFO', user)
              resolve(user)
            }
          }).catch(error => {
            reject(error);
          });
        }
      })
    },
    // 账号密码登录
    Login({ commit, state
    }, userInfo) {
      commit('SET_TOKEN', '');
      commit('SET_JWTDECODE', {});
      commit("SET_SALARYPASS", '');
      removeToken();
      removeSalaryPass();
      let parm = {};
      let individualFlag=false;
       if(getIndividualHeaderKey()){ // 表示个体户登录
           individualFlag=true;
       }
      if (userInfo.type == "password") {
        parm = { username: userInfo.tel, password: userInfo.password, grant_type: userInfo.type,individualFlag:individualFlag }
      } else if (userInfo.type=="easy_register"){
        parm = { username: userInfo.tel, code: userInfo.code, grant_type: userInfo.type, token: userInfo.token,individualFlag:individualFlag }
      }else{
        parm = { username: userInfo.tel, password: userInfo.password, grant_type: userInfo.type, token: userInfo.token,individualFlag:individualFlag }
      }
      return new Promise((resolve, reject) => {
        api.login(parm, { method: 'post' })
          .then(response => {
            if (response.data.status == '200') {
              //小程序传openId
              if (state.browserUA == "MINI" && state.wxMiniOpenId) {
                api.setMiniOpenId({}, { method: 'patch', subUrl: state.wxMiniOpenId })
              }

              if (response.data.data.passwordFlag == '1') {
                setToken(response.data.data.token);
                commit('SET_TOKEN', response.data.data.token);
                commit('SET_JWTDECODE', jwt_decode(response.data.data.token));

                removePartnerToken(); // 清空合作方token
                commit('SET_PARTNER_TOKEN', '');
                commit('SET_PARTNERJWTDECODE', {});

                // 设置appToken
                setAppToken(response.data.data.grejobAppOauthLogin);
                commit('SET_APP_TOKEN', response.data.data.grejobAppOauthLogin);



                //设置openid
                if (typeof getWechatAutoLoginCode() != 'undefined') {
                  employeeSetOidByCode({ code: getWechatAutoLoginCode() });
                  removeWechatAutoLoginCode();
                }
              }
              resolve(response.data);
            } else {
              resolve(response.data);
            }

          })
          .catch(error => {
            reject(error);
          });
      });
    },
    //小程序通过openId获取token
    async getMiniToken({ commit }, openId) {
      let res = await api.getTokenByMiniOpenid({}, { subUrl: openId });
      return new Promise((resolve, reject) => {
        if (res.data.data) {
          setToken(res.data.data);
          commit('SET_TOKEN', res.data.data);
          commit('SET_JWTDECODE', jwt_decode(res.data.data));
          removePartnerToken(); // 清空合作方token
          commit('SET_PARTNER_TOKEN', '');
          commit('SET_PARTNERJWTDECODE', {});
          resolve()
        } else {
          reject()
        }
      })
    },

    EmployeePasswordValidate({ commit
    }, password) {
      return new Promise((resolve, reject) => {
        employeePasswordValidate({ password: password })
          .then(response => {
            if (response.data.status == "200") {
              commit("SET_SALARYPASS", password);
              commit("SET_SHOWSALARYPASS", false);
              setSalaryPass(password);
            }
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    //微信自动登录
    wechatAutoLogin({ commit
    }, path) {
      return new Promise((resolve, reject) => {
        let url = window.location.href;
        //是否为微信自动登录回调
        if (typeof getWechatAutoLoginFlag() == 'undefined') {
          removeWechatAutoLoginCode();
          url = url.substring(0, url.indexOf("#") + 1) + path;
          let encodeUrl = encodeURIComponent(url);
          console.log('redirect_uri', url, encodeUrl)
          window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + process.env.VUE_APP_WXAPPID + "&redirect_uri=" + encodeUrl + "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect");
          setWechatAutoLoginFlag(1);
        } else {
          removeWechatAutoLoginFlag();
          let code = url.substring(url.indexOf("code=") + 5, url.indexOf("&state=STATE"));
          if (code == "http") {
            resolve(true);
          } else {
            setWechatAutoLoginCode(code);
            api.getTokenByWechatCode({ code: code }, { method: 'post' })
              .then(response => {
                if (response.data.status == '200') {
                  if (response.data.data) {
                    setToken(response.data.data);
                    commit('SET_TOKEN', response.data.data);
                    commit('SET_JWTDECODE', jwt_decode(response.data.data));

                    removePartnerToken(); // 清空合作方token
                    commit('SET_PARTNER_TOKEN', '');
                    commit('SET_PARTNERJWTDECODE', {});

                    resolve(response.data);
                  } else {
                    resolve(true);
                  }
                } else {
                  resolve(response.data);
                }
              })
              .catch(error => {
                reject(error);
              });
          }
        }
      });

    },

    //app自动登录
    appAutoLogin({ commit
    }, path) {
      return new Promise((resolve, reject) => {
        let url = window.location.href;
        api.getTokenByAppCode({ code: getAppToken() }, { method: 'post' })
          .then(response => {
            if (response.data.status == '200') {
              if (response.data.data) {
                setToken(response.data.data);
                commit('SET_TOKEN', response.data.data);
                commit('SET_APP_TOKEN', response.data.data);
                commit('SET_JWTDECODE', jwt_decode(response.data.data));

                removePartnerToken(); // 清空合作方token
                commit('SET_PARTNER_TOKEN', '');
                commit('SET_PARTNERJWTDECODE', {});

                resolve(response.data);
              } else {
                resolve(true);
              }
            } else {
              resolve(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });

    },


    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_JWTDECODE', {});
        commit("SET_SALARYPASS", '');
        removeToken();
        removeSalaryPass();
        removeAppToken();
        removeCompanyCodeHeaderKey();
        removeIndividualHeaderKey();
        sessionStorage.removeItem('identityFlag');

        // 删除cookie
        clearCookie('Green-Job-Mobile');
        clearCookie('identityFlag');
        clearCookie('individualHeader');
        clearCookie('Green-Job-Salary-Pass');
        clearCookie('grejobAppOauthLogin');
        clearCookie('companyCodeHeader');
          resolve();
      });
    },
  }
};

export default user;
